import _slicedToArray from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getShopDataAnalyse, shopDataDownload, getSpuGroupList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import * as DateUtil from '@/utils/date';
import { saveAs } from 'file-saver';

var _this;

export default {
  name: 'BairunBianlidianShiftCount',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatTime: function formatTime(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'MM-dd hh:mm');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getShopDataAnalyse,
      type: '',
      loading: false,
      summarieObj: {
        'totalAnalysisDays': 0,
        'totalOrderSaleAmount': 0,
        'totalOrderPay': 0,
        'totalGoodsCost': 0,
        'totalGrossProfit': 0,
        'totalTicketDiscount': 0,
        'totalPointDiscount': 0,
        'totalGoodsDiscount': 0
      },
      searchSpuGroupOptions: [],
      searchInfo: {
        dataType: 14,
        period: 0,
        dateTime: new Date(),
        startTime: '',
        endTime: '',
        timeTag: 'date',
        spuNoStr: ''
      },
      endTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          // return ture表示日期不可选
          return !DateUtil.isBeforeMonth(_this.searchInfo.startTime, time.Format('yyyy-MM-dd hh:mm:ss'), 1, 'date');
        }
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var searchSpuGroupOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getSpuGroupList({
                  page: 1,
                  pageSize: 999999,
                  spuGroupStatus: 1,
                  donNotShowLoading: true
                });

              case 2:
                searchSpuGroupOptions = _context3.sent;
                _this3.searchSpuGroupOptions = searchSpuGroupOptions.data.list || [];

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onInputChange: function onInputChange() {
      this.$forceUpdate();
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      if (this.searchInfo.timeTag === 'custom') {
        this.searchInfo.period = 0;
      } else {
        var _DateUtil$getStartAnd = DateUtil.getStartAndEnd(this.searchInfo.timeTag, this.searchInfo.dateTime);

        var _DateUtil$getStartAnd2 = _slicedToArray(_DateUtil$getStartAnd, 3);

        this.searchInfo.startTime = _DateUtil$getStartAnd2[0];
        this.searchInfo.endTime = _DateUtil$getStartAnd2[1];
        this.searchInfo.period = _DateUtil$getStartAnd2[2];
      }

      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        return;
      }

      this.getTableData(this.page, this.pageSize, function (res) {
        _this4.summarieObj = res.data.heji;
      });
    },
    getSummaries: function getSummaries() {
      return ['合计', '', this.summarieObj.totalOrderSaleAmount, this.summarieObj.totalTicketDiscount, this.summarieObj.totalPointDiscount, this.summarieObj.totalGoodsDiscount, this.summarieObj.totalOrderPay, this.summarieObj.totalGoodsCost, this.summarieObj.totalGrossProfit];
    },
    onDownload: function onDownload() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return shopDataDownload(_this5.searchInfo);

              case 2:
                res = _context4.sent;

                if (res.code == 0) {
                  saveAs(res.data.fileUrl);
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};